declare var swal: any;
import { Component, OnInit } from '@angular/core';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbAddCodedtypeModal } from './modal/addcodedtype.modal';
import { NgbEditcodedtypeModal } from './modal/editcodedtype.modal';
import { CodeTypesController } from '../../../../../../src/app/ncs/models/master/mastermodel';
import { CodeTypeRequest, LongCodeTypeValueController, LongCodeTypeValueRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { CodeTypePipeNew, CodeValuesPipeNew } from '../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
@Component({
  selector: 'app-codetypes',
  templateUrl: './codetypes.component.html',
  styleUrls: ['./codetypes.component.css']
})
export class CodetypesComponent implements OnInit {
  public ShowList: boolean = true;
  public ShowService: boolean = false;
  public ShowService1: boolean = true;
  public isRequesting: boolean = false;
  public ShowButton: boolean = true;
  public ApiResData: ApiResponseModel;
  searchTitle: string;
  ValidFrom: NgbDateStruct;

  CurrentSaveCodedValuesRequest: LongCodeTypeValueRequest;
  CurrentCodeTypesController: CodeTypesController[];
  CurrentCodeTypeRequest: CodeTypeRequest;
  LoadCodeTypes() {
    this.CurrentCodeTypeRequest = new CodeTypeRequest();
    this.CurrentCodeTypeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentCodeTypesController;
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentCodeTypeRequest.ConditionalOperator = 10;
    this.CurrentCodeTypeRequest.AllowHierarchy = true;
    this.CurrentCodeTypeRequest.CodeTypesCode = 0;
    this.CurrentCodeTypeRequest.Name = "";
    this.CurrentCodeTypeRequest.ShortName = "";
      this.GetCodeTypesController();
  }

  GetCodeTypesController() {
    this.StartRefreshing();


    this.actorservice.GetCodeTypesController(this.CurrentCodeTypeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCodeTypesController = this.ApiResData.Result || (this.ApiResData as any).result || [];
          this.pdata = this.CurrentCodeTypesController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadPlan();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  constructor(private modalService: NgbModal, private loaderService: SpinnerService, private actorservice: ActorService, private filter: CodeTypePipeNew, private filter2: CodeValuesPipeNew, private tosterservice: NGXToastrService,) { }

  ngOnInit() {
    this.LoadCodeTypes();
    this.CurrentSaveCodedValuesRequest = new LongCodeTypeValueRequest();
    this.CurrentSaveCodedValuesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentEditLongCodeTypeValueRequest = new LongCodeTypeValueRequest();
    this.CurrentEditLongCodeTypeValueRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.LoadRegistries();
  }
  //LoadRegistries() {
  //  this.StartRefreshing();

  //}
  SelectedCodedType: CodeTypesController;
  viewcodedtypes(objCategory: any) {
    var Codedtype: CodeTypesController = objCategory;
    if (Codedtype != null) {
      this.SelectedCodedType = null;
      this.SelectedCodedType = Codedtype;
      this.ShowList = true;
      this.ShowService = true;
      this.ShowService1 = false;
      this.ShowButton = false;
      this.LoadCodeValues();
    }
    else {

    }
   

  }
  CurrentLongCodeTypeValueController: LongCodeTypeValueController[];
  CurrentLongCodeTypeValueRequest: LongCodeTypeValueRequest;
  CurrentEditLongCodeTypeValueRequest: LongCodeTypeValueRequest;
  LoadCodeValues() {
    this.CurrentLongCodeTypeValueRequest = new LongCodeTypeValueRequest();
    this.CurrentLongCodeTypeValueRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata2 = this.CurrentLongCodeTypeValueController;
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentLongCodeTypeValueRequest.ConditionalOperator = 10;
    this.CurrentLongCodeTypeValueRequest.CodeTypeValueCode = 0;
    this.CurrentLongCodeTypeValueRequest.LongValue = "";
    this.CurrentLongCodeTypeValueRequest.ShortValue = "";
    this.CurrentLongCodeTypeValueRequest.CodeType = this.SelectedCodedType.ShortName.toString();
    this.CurrentLongCodeTypeValueRequest.ParentValue = "";
    this.CurrentLongCodeTypeValueRequest.SeqNo = 0;
    
    //this.CurrentLongCodeTypeValueRequest.CodeType = "";

    this.GetLongCodeTypeValueController();
  }

  GetLongCodeTypeValueController() {
    this.StartRefreshing();


    this.actorservice.GetLongCodeTypeValueController(this.CurrentLongCodeTypeValueRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentLongCodeTypeValueController = this.ApiResData.Result || (this.ApiResData as any).result || [];
          this.pdata2 = this.CurrentLongCodeTypeValueController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadPlan();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentCodeTypesController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentCodeTypesController,
          this.listFilter);
      }
    }
  }
  pdata2: any[];// = this.data;
  listFilter2: string;
  ngOnChanges2(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata2 = this.CurrentLongCodeTypeValueController;

    this.criteriaChange2(this.listFilter);
  }
  criteriaChange2(value: any) {
    if (this.filter2 != null) {
      if (value != '[object Event]') {
        this.listFilter2 = value;
        //alert(this.listFilter);
        this.pdata2 = this.filter2.transform(this.CurrentLongCodeTypeValueController,
          this.listFilter2);
      }
    }
  }
  newmodal1() {
    const modalRef = this.modalService.open(NgbAddCodedtypeModal,
      {
        centered: true,

        })
      modalRef.result.then(x => { this.GetCodeTypesController() })
  }
  //Editactivities(l: IvfPlanActivityTemplateController) {
  //  this.CurrentEditIvfPlanActivityTemplateRequest.ActivityDescription = l.ActivityDescription
  //  this.CurrentEditIvfPlanActivityTemplateRequest.ActivityTemplateCode = l.ActivityTemplateCode;
  //  this.CurrentEditIvfPlanActivityTemplateRequest.ActivityType = l.ActivityType;
  //  this.CurrentEditIvfPlanActivityTemplateRequest.ApplicableTo = l.ApplicableTo;
  //  this.CurrentEditIvfPlanActivityTemplateRequest.DOC = l.DOC;
  //  this.CurrentEditIvfPlanActivityTemplateRequest.SeqNo = l.SeqNo;
  //  this.CurrentEditIvfPlanActivityTemplateRequest.Remarks = l.Remarks;
  //  this.CurrentEditIvfPlanActivityTemplateRequest.TemplateCode = this.SelectedTemplate.PlanTemplateCode;
  //  this.CurrentEditIvfPlanActivityTemplateRequest.Protocol = this.SelectedTemplate.Protocol;
  //  this.CurrentEditIvfPlanActivityTemplateRequest.CycleType = this.SelectedTemplate.CycleType;
  //  this.CurrentEditIvfPlanActivityTemplateRequest.ServiceName = l.ServiceName;
  //  this.CurrentEditIvfPlanActivityTemplateRequest.ServiceCode = l.ServiceCode;
  //  const modalRef = this.modalService.open(NgbEditactivitiesModal,
  //    {
  //      centered: true

  //    })
  //  modalRef.componentInstance.CurrentEditIvfPlanActivityTemplateRequest = this.CurrentEditIvfPlanActivityTemplateRequest;
  //  modalRef.result.then(x => { this.GetIvfPlanActivityTemplateController() })
  //}
  editmodal(l: LongCodeTypeValueController) {
    this.CurrentEditLongCodeTypeValueRequest.LongValue = l.LongValue;
    this.CurrentEditLongCodeTypeValueRequest.ShortValue = l.ShortValue;
    this.CurrentEditLongCodeTypeValueRequest.CodeTypeValueCode = l.Code;
    this.CurrentEditLongCodeTypeValueRequest.CodeType = l.CodeType;
    const modalRef = this.modalService.open(NgbEditcodedtypeModal,
      {
        centered: true,

      })
    modalRef.componentInstance.CurrentEditLongCodeTypeValueRequest = this.CurrentEditLongCodeTypeValueRequest;
    modalRef.result.then(x => { this.GetLongCodeTypeValueController() })
  }
  clearData() {
    this.CurrentSaveCodedValuesRequest.LongValue = null;
    this.CurrentSaveCodedValuesRequest.ShortValue = null;
 }
  onSubmit() {
    // alert("On Submit");
    this.StartRefreshing();
    this.CurrentSaveCodedValuesRequest.CodeTypeValueCode = 0;
    this.CurrentSaveCodedValuesRequest.CodeType = this.SelectedCodedType.ShortName.toString();
    this.CurrentSaveCodedValuesRequest.ParentValue = "";
    this.CurrentSaveCodedValuesRequest.SeqNo = 0;
    //this.CurrentSaveCodedValuesRequest.CodeType = "10";
    this.CurrentSaveCodedValuesRequest.ConditionalOperator = 1;

    this.actorservice.SaveCodeTypeValues(this.CurrentSaveCodedValuesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.ShowList = true;
            this.clearData();
            //this.LoadActivity();
            this.LoadCodeValues();

            this.stopRefreshing();
            
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  delcodetype(l: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentitiescodetype(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentitiescodetype(l: any) {
    var item2 = l as LongCodeTypeValueController;

    console.log('..................');
    this.StartRefreshing();
    this.CurrentEditLongCodeTypeValueRequest.ConditionalOperator = 3;

    this.CurrentEditLongCodeTypeValueRequest.LongValue = item2.LongValue;
    this.CurrentEditLongCodeTypeValueRequest.ShortValue = item2.ShortValue;
    this.CurrentEditLongCodeTypeValueRequest.CodeTypeValueCode = item2.Code;
    this.CurrentEditLongCodeTypeValueRequest.CodeType = item2.CodeType;
    //this.CurrentSaveCodedValuesRequest.CodeType = this.SelectedCodedType.ShortName.toString();
    //this.CurrentSaveCodedValuesRequest.LongValue = item2.LongValue;
    //this.CurrentSaveCodedValuesRequest.ParentValue = item2.ParentValue;
    //this.CurrentSaveCodedValuesRequest.SeqNo = item2.SeqNo;
    //this.CurrentSaveCodedValuesRequest.ShortValue = item2.ShortValue;
    //this.CurrentSaveCodedValuesRequest.CodeTypeValueCode = this.SelectedCodedType;
  
    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveCodeTypeValues(this.CurrentEditLongCodeTypeValueRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            //this.ShowList = true;
            this.LoadCodeValues();

            this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
}
